<div class="panel panel-success">
    <div class="panel-heading">
        <h5 style="display: inline-block">
            <span>
                Projects   
                <span class="badge">
                    {{All_Projects_With_Details?.length}}
                </span>
            </span>
        </h5>
    </div>
    <div class="panel-body panel-list" style="height: 380px;">
        <div *ngIf="Is_Processing" class="list-group" style="overflow-y: scroll;
        max-height: 600px;">
            <i class="fa fa-spinner fa-spin"></i> Loading projects...
        </div>
        <div *ngIf="All_Projects_With_Details?.length>0" class="panel-group" style="height:450px">
            <div style="padding: 0;">
                <div class="panel-group">
                    <div class="panel company-panel" *ngFor ="let i of All_Projects_With_Details">
                        <div class="panel-heading">
                            <h5 style="display: inline-block;">
                                <span class="badge">
                                    {{i.ProjectDetails?.length}}
                                </span>
                                <span [ngClass]="textColor">{{i.Project_Title}}</span>
                            </h5>
                            <div class="pull-right btn-toolbar" role="toolbar">
                                <div class="btn-group btn-group-sm">
                                    <button *ngIf="i.ProjectDetails?.length > 0" type="button" class="btn btn-info" title="Show Project Details" (click)="OpenProjectDetails(i.Project_ID)">
                                        <span data-toggle="tooltip" class="fa fa-lg" [ngClass]="(i.Project_ID==Selected_project_ID)?'fa-chevron-up':'fa-chevron-down'"></span>
                                    </button>
                                    <button type="button" class="btn btn-info" title="Remove Project"  (click)="DeleteProject(i.Project_ID,i.Project_Title)">
                                        <span data-toggle="tooltip" class="fa fa-trash-o fa-lg"></span>
                                    </button>
                                </div>

                                <div class="btn-group btn-group-sm" *ngIf="i.ProjectDetails?.length > 0">
                                    <button type="button" class="btn btn-info" title="Publish Project" (click)="ShowModalPublishProject(i.Project_ID,i.Project_Title)">
                                        <span data-toggle="tooltip" class="fa fa-upload fa-lg"></span>
                                    </button>
                                </div>
                            </div>

                            <div class="clearfix"></div>
                        </div>
                        <ng-container *ngFor="let j of i.ProjectDetails">
                            <div class="panel-group" *ngIf="i.Project_ID==Selected_project_ID">
                                <div class="panel"  [ngClass]="(j.Active)?'minesite-panel':'info-warning-custom'">
                                    <div class="panel-heading">
                                        <h5 style="display: inline-block">
                                            <span style="color:white">{{j.Name}} ({{j.Created_Date}})</span><br />
                                            <span class="badge">{{j.label}}</span>
                                        </h5>
                                        <div class="pull-right btn-toolbar" role="toolbar">
                                            <div class="btn-group btn-group-sm">
                                                <button  [ngStyle]="{'cursor': (j.Can_Changed) ? 'pointer' : 'no-drop'}" type="button" class="btn btn-info" title="Undo Project Detail" (click)="DeleteProjectDetail(i.Project_ID,j.Status,j.ID)">
                                                    <span data-toggle="tooltip" class="fa fa-undo fa-lg"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                     
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div bsModal #ProjectPublish="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Publish the {{Project_Title}}
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to Publish project: <b>{{Project_Title}}</b>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-warning" type="button" (click)="PublishProject()">Confirm Publish</button>
                <button class="btn btn-primary" type="button" (click)="Close()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #DeleteProjectConfirmation="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Delete {{Project_Title}}
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to Delete project: <b>{{Project_Title}}</b>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-warning" type="button" (click)="DeleteSelectedProject()">Confirm Delete</button>
                <button class="btn btn-primary" type="button" (click)="Close()">Cancel</button>
            </div>
        </div>
    </div>
</div>